import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { apiMessageQueries } from '@/services/apiMessage/apiMessage.queries';
import { useSearch } from '@tanstack/react-router';

export const useApiMessageList = () => {
  const { createdDate, page, fetch, q } = useSearch({
    from: '/(app)/logs-management/api-logs/',
  });

  const parsedCreatedDate = parseDateRangeSearch(createdDate);

  const { data, isLoading } = useQuery({
    ...apiMessageQueries.list({
      fromDate: parsedCreatedDate.start,
      toDate: parsedCreatedDate.end,
      row: page,
      fetch,
      searchText: q,
    }),
  });

  return {
    apiMessages: data?.data || [],
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
  };
};
